module.exports = __webpack_public_path__ + "static/media/default-img.c0bcfdc4.jpg";